import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'common-ui-components/dist/components/Atoms/Notification';
import Modal from 'common-ui-components/dist/components/Atoms/Modal';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import './ShareCart.scss';

const ShareCartSuccessModal = props => {
  const { showShareCartSuccessModal, setShareCartModalClose, labels, config } = props;

  const { shareShoppingCart, close, emailSent } = labels;
  const { shareCartIcon, successIconUrl } = config;

  const modalHeading = () => <Notification title={shareShoppingCart} icon={shareCartIcon} />;
  const modalProps = {
    className: 'modal__Content share-cart-success-modal',
    shouldCloseOnOverlayClick: true,
    isOpen: showShareCartSuccessModal,
    onRequestClose: () => setShareCartModalClose(false),
    heading: modalHeading(),
  };
  const buttonProps = {
    className: 'primary share-cart-success-close-button',
    elementLocator: 'button-share-cart-submit',
    onClick: () => setShareCartModalClose(false),
  };
  return (
    <Modal {...modalProps}>
      <>
        <div className="row">
          <div className="col-xs-12 email-sent" data-locator="share-cart-email-sent">
            <Notification
              variation="inline"
              description={emailSent}
              icon={successIconUrl}
              elementLocator="notification-share-cart-email-sent"
            />
          </div>
          <div className="col-xs-12">
            <Button {...buttonProps}>{close}</Button>
          </div>
        </div>
      </>
    </Modal>
  );
};

ShareCartSuccessModal.propTypes = {
  showShareCartSuccessModal: PropTypes.bool,
  setShareCartModalClose: PropTypes.func,
  labels: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.objectOf(PropTypes.string),
  errorObj: PropTypes.shape({ error: PropTypes.string }),
};

ShareCartSuccessModal.defaultProps = {
  showShareCartSuccessModal: false,
  labels: {},
  config: {},
  errorObj: {},
  setShareCartModalClose: () => {
    /* default setShareCartModalClose handler */
  },
};

export default ShareCartSuccessModal;
